import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';
import type { MarktAkquiseStatus } from './MarktAkquiseStatus.js';

/**
 * @entity MarktAkquiseContactRecord
 */
@Entity()
export class MarktAkquiseContactRecord extends AdornisEntity {
  public static override _class = 'MarktAkquiseContactRecord';

  public static override resolveID(entity: any): string {
    return A.getGloballyUniqueID();
  }

  @Field(type => String)
  fromID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ fromID }) => fromID)
  from: Maybe<ChancenwerkUser>;

  @Field(type => String)
  toID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ toID }) => toID)
  to: Maybe<ChancenwerkUser>;

  @Field(type => DateTime)
  when: Maybe<DateTime>;

  @Field(type => String)
  response: Maybe<string>;

  @Field(type => String)
  nextStep: Maybe<string>;

  @Field(type => DateTime)
  nextStepWhen: Maybe<DateTime>;

  @Field(type => String)
  status: Maybe<MarktAkquiseStatus>;
}
